var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createLanguageService = void 0;
const completions = require("./services/completions/basic");
const directiveCommentCompletions = require("./services/completions/directiveComment");
const jsDocCompletions = require("./services/completions/jsDoc");
const completionResolve = require("./services/completions/resolve");
const definitions = require("./services/definition");
const typeDefinitions = require("./services/typeDefinition");
const references = require("./services/references");
const fileReferences = require("./services/fileReferences");
const prepareRename = require("./services/prepareRename");
const rename = require("./services/rename");
const fileRename = require("./services/fileRename");
const codeActions = require("./services/codeAction");
const codeActionResolve = require("./services/codeActionResolve");
const hover = require("./services/hover");
const signatureHelp = require("./services/signatureHelp");
const selectionRanges = require("./services/selectionRanges");
const diagnostics = require("./services/diagnostics");
const documentHighlight = require("./services/documentHighlight");
const documentSymbol = require("./services/documentSymbol");
const workspaceSymbols = require("./services/workspaceSymbol");
const formatting = require("./services/formatting");
const semanticTokens = require("./services/semanticTokens");
const foldingRanges = require("./services/foldingRanges");
const callHierarchy = require("./services/callHierarchy");
const implementation = require("./services/implementation");
const inlayHints = require("./services/inlayHints");
const vscode_languageserver_textdocument_1 = require("vscode-languageserver-textdocument");
const shared = require("@volar/shared");
__exportStar(require("./configs/getFormatCodeSettings"), exports);
__exportStar(require("./configs/getUserPreferences"), exports);
;
function createLanguageService(ts, host, languageService, getConfiguration, rootUri) {
    const documents = new Map();
    return {
        findDefinition: definitions.register(languageService, getTextDocument),
        findTypeDefinition: typeDefinitions.register(languageService, getTextDocument),
        findReferences: references.register(languageService, getTextDocument),
        findFileReferences: fileReferences.register(languageService, getTextDocument),
        findImplementations: implementation.register(languageService, getTextDocument),
        prepareRename: prepareRename.register(languageService, getTextDocument),
        doRename: rename.register(rootUri, languageService, getTextDocument, getConfiguration),
        getEditsForFileRename: fileRename.register(rootUri, languageService, getTextDocument, getConfiguration),
        getCodeActions: codeActions.register(rootUri, languageService, getTextDocument, getConfiguration),
        doCodeActionResolve: codeActionResolve.register(rootUri, languageService, getTextDocument, getConfiguration),
        getInlayHints: inlayHints.register(rootUri, languageService, getTextDocument, getConfiguration, ts),
        findDocumentHighlights: documentHighlight.register(languageService, getTextDocument, ts),
        findDocumentSymbols: documentSymbol.register(languageService, getTextDocument),
        findWorkspaceSymbols: workspaceSymbols.register(languageService, getTextDocument),
        doComplete: completions.register(rootUri, languageService, getTextDocument, getConfiguration, ts),
        doCompletionResolve: completionResolve.register(rootUri, languageService, getTextDocument, getConfiguration),
        doDirectiveCommentComplete: directiveCommentCompletions.register(getTextDocument),
        doJsDocComplete: jsDocCompletions.register(languageService, getTextDocument),
        doHover: hover.register(languageService, getTextDocument, ts),
        doFormatting: formatting.register(languageService, getTextDocument, getConfiguration),
        getSignatureHelp: signatureHelp.register(languageService, getTextDocument, ts),
        getSelectionRanges: selectionRanges.register(languageService, getTextDocument),
        doValidation: diagnostics.register(host, languageService, getTextDocument, ts),
        getFoldingRanges: foldingRanges.register(languageService, getTextDocument, ts),
        getDocumentSemanticTokens: semanticTokens.register(host, languageService, getTextDocument, ts),
        callHierarchy: callHierarchy.register(languageService, getTextDocument),
    };
    function getTextDocument(uri) {
        var _a;
        const fileName = shared.uriToFileName(uri);
        const version = host.getScriptVersion(fileName);
        const oldDoc = documents.get(uri);
        if (!oldDoc || oldDoc[0] !== version) {
            const scriptSnapshot = host.getScriptSnapshot(fileName);
            if (scriptSnapshot) {
                const scriptText = scriptSnapshot.getText(0, scriptSnapshot.getLength());
                const document = vscode_languageserver_textdocument_1.TextDocument.create(uri, shared.syntaxToLanguageId(uri.substring(uri.lastIndexOf('.') + 1)), oldDoc ? oldDoc[1].version + 1 : 0, scriptText);
                documents.set(uri, [version, document]);
            }
        }
        return (_a = documents.get(uri)) === null || _a === void 0 ? void 0 : _a[1];
    }
}
exports.createLanguageService = createLanguageService;
//# sourceMappingURL=createLanguageService.js.map